export default (function (value) {
  return typeof value === 'string';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isString.js
// module id = tvs0
// module chunks = 0